import { render, staticRenderFns } from "./hunt-winner-slide.vue?vue&type=template&id=1fa92fc3&scoped=true&"
import script from "./hunt-winner-slide.vue?vue&type=script&lang=js&"
export * from "./hunt-winner-slide.vue?vue&type=script&lang=js&"
import style0 from "./hunt-winner-slide.vue?vue&type=style&index=0&id=1fa92fc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa92fc3",
  null
  
)

export default component.exports